var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShooting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.001,
    height: 38,
    viewBox: "0 0 38.001 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SHOOTING",
    transform: "translate(-1924.99 -7204.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-1",
    d: "M2056.732,7325.986V7324.4h-1.458v1.582a9.883,9.883,0,0,0-9.109,9.11h-1.582v1.458h1.582a9.879,9.879,0,0,0,9.109,9.107v1.582h1.458v-1.582a9.879,9.879,0,0,0,9.109-9.107h1.583V7335.1h-1.583A9.883,9.883,0,0,0,2056.732,7325.986Zm0,18.213v-1.521h-1.458v1.521a8.419,8.419,0,0,1-7.646-7.645h1.522V7335.1h-1.522a8.422,8.422,0,0,1,7.646-7.646v1.521h1.458v-1.521a8.423,8.423,0,0,1,7.646,7.646h-1.523v1.458h1.523A8.421,8.421,0,0,1,2056.732,7344.2Z",
    transform: "translate(-112.013 -112.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-1",
    d: "M1957.426,7210.375a19,19,0,1,0,5.565,13.437A18.879,18.879,0,0,0,1957.426,7210.375Zm-1.031,25.841a17.413,17.413,0,0,1-11.676,5.123v-3.823h-1.458v3.823a17.54,17.54,0,0,1-16.8-16.8h3.823v-1.456h-3.823a17.54,17.54,0,0,1,16.8-16.8v3.824h1.458v-3.824a17.541,17.541,0,0,1,16.8,16.8h-3.823v1.456h3.823A17.417,17.417,0,0,1,1956.4,7236.216Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-1",
    d: "M2191.721,7468.528h-1.458v1.555h-1.555v1.46h1.555v1.553h1.458v-1.553h1.555v-1.46h-1.555Z",
    transform: "translate(-247.001 -247)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShooting);
export default __webpack_public_path__ + "static/media/shooting.ffc86ba4b50753007e9ddfc3104c582e.svg";
export { ForwardRef as ReactComponent };